import { queryOptions, useQuery } from '@tanstack/react-query';
import type { FoodOrderSearch } from '../model/schema';
import { foodOrderApi, foodOrderQuery } from './food-order-api';
export const foodOrderKeys = {
  all: ['food-orders'] as const,
  lists: () => [...foodOrderKeys.all, 'list'] as const,
  list: (params: FoodOrderSearch) =>
    [...foodOrderKeys.lists(), params.scope, foodOrderQuery(params)] as const,
  detail: (id: string) => [...foodOrderKeys.all, 'detail', id] as const,
};
export const foodOrderQueries = {
  list: (params: FoodOrderSearch) =>
    queryOptions({
      queryKey: foodOrderKeys.list(params),
      queryFn: ({ signal }) => foodOrderApi.list(params, signal),
      enabled: params.scope === 'by-merchant' || Boolean(params.entityId),
    }),
  detail: (id: string) =>
    queryOptions({
      queryKey: foodOrderKeys.detail(id),
      queryFn: ({ signal }) => foodOrderApi.detail(id, signal),
      enabled: Boolean(id),
    }),
};
export const useFoodOrders = (params: FoodOrderSearch) =>
  useQuery(foodOrderQueries.list(params));
export const useFoodOrder = (id: string) => useQuery(foodOrderQueries.detail(id));
